import { NetworkStateNew } from '@shared/ui/network-state-new/network-state-new';
import { styled } from 'goober';
import { ReactNode } from 'react';

export const MainActions = styled('div')`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-flow: 'row';
    gap: 20px;
`;

export const StyledNetworkStateNew = styled(NetworkStateNew)<{ children?: ReactNode }>`
    height: fit-content !important;
    flex-grow: 0 !important;
`;
